<!--
 * @Author       : qixiao
 * @Date         : 2023-05-13 17:14:06
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-16 08:51:27
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\AgriculturalMonitoring\component\searchs.vue
 * @Description  : 
 * 
-->

<template>
  <div class="pages">
    <div class="search-wrap">
      <div class="search-ipt-element">
        <!-- <div class="search-prepend">
          <div class="search-prepend-inner" @click="showCityFlag = true">
            <span
              :class="[curCityName.length > 3 ? 'ellipsis' : '', 'city-name']"
              >{{ curCityName }}</span
            >
          </div>
        </div> -->
        <el-select
          ref="select"
          class="hxstyle-input-select-ele"
          v-model="query.masterName"
          clearable
          filterable
          remote
          :remote-method="remoteSearch"
          placeholder="请输入/选择合作社名称"
          @focus="searchON('e')"
        >
        <!-- @clear="clearKeyword" -->
        <!-- @click.native="handleSelect(item)" -->
        <!-- @keyup.enter.native="handleSelect()" -->

          <el-option
            v-for="item in communityList"
            :key="item.accountId"
            :label="item.cooperativeName"
            :value="item.accountId"
          >
            <div class="search-key-item">
              <div class="search-key-item-cont"></div>
              <div class="search-key-item-num" v-html="item.parseName"></div>
            </div>
          </el-option>
          <p class="loading-txt" v-if="loading">
            <i class="el-icon-loading"></i>
            正在加载中...
          </p>
          <div class="option-empty" slot="empty">
            未搜索到与"<span class="option-empty-tip">{{
              query.masterName
            }}</span
            >"相关的合作社
          </div>
        </el-select>
        <el-input v-model="query.searchName" placeholder="请输入设备号/设备名称"></el-input>
        <el-button type="success" slot class="append-btn" @click="handleSelect"
          >搜索</el-button
        >
        <el-button type="primary" icon="el-icon-refresh-right" plain  @click="reset">重置</el-button>
          </el-form-item>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "./LandMapNq/js/bus";
import { mapActions } from "vuex";

export default {
  components: {},
  props: [],
  data() {
    return {
      scrollShow: false,
      showCityFlag: false,
      communityList: [],
      loading: false,
      hasLocated: false,
      query: {
        masterName: "",
        cityCode: "",
        searchName:"",
        isMatchAddr: true,
        pageNo: 1,
        size: 20,
      },
      curCityName: "",
      selectParams: {
        collectType: "2",
        provinceId: "",
        cityId: "",
        areaId: "",
        bedroom: -1,
        livingRoom: -1,
        kitchen: -1,
        pageNo: 1,
        size: 20,
        bathroom: -1,
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    ...mapActions(["changeSearchName"]),
    remoteSearch(data) {
      console.log("remoteSearch---data:", data);
      this.query.masterName = data;
      this.query.pageNo = 1;
      this.communityList = [];
      this.querySearch();
    },
    //点击搜索item的逻辑
    handleSelect() {
      console.log(this.$refs.select.value);
      // bus.$emit("masterId", this.$refs.select.value);
      // bus.$emit("searchName", this.query.searchName);
      // sessionStorage.setItem('masterId',this.$refs.select.value)
      // sessionStorage.setItem('searchName',this.query.searchName)
      // this.resetSetItem('masterId', this.$refs.select.value);
      // this.resetSetItem('searchName', this.query.searchName);
      // console.log(this.$store.state.Agricultural.searchName);
      // this.changeSearchName(this.$refs.select.value)
        // console.log(this.$store.state.Agricultural.commit('changeSearchName',this.$refs.select.value));
        // this.changeSearchName(this.query.searchName)
        // console.log(this.$store.state.Agricultural.searchName);
        this.$emit('changeMasterId',this.$refs.select.value)
        this.$emit('changeSearchName',this.query.searchName)
    },
    //搜索关键词请求接口的逻辑
    querySearch() {
      this.$http.nqMonitor
        .listOfCooperatives(this.query)
        .then((res) => {
          console.log(res);
          this.communityList = res.data || [];
          this.communityList = this.setHightLight(
            this.communityList,
            this.query.masterName
          );
          console.log(this.query.masterName);
          // console.log(
          //   this.setHightLight(this.communityList, this.query.masterName)
          // );
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    //设置高亮的逻辑
    setHightLight(arr, keyword) {
      console.log(arr, keyword);
      if (arr && arr.length > 0) {
        arr = arr.filter((item) => {
          let reg = new RegExp(
            this.formatForKeyword(this.query.masterName),
            "g"
          );
          let replaceString = `<span style="color:#f00;padding:0">${keyword}</span>`;
          console.log(replaceString);
          if (item.cooperativeName.match(reg)) {
            //为了不影响原始name，我们这里给item重新设置一个parseName，模板中显示的是parseName
            item.parseName = item.cooperativeName.replace(reg, replaceString);
            return item;
          }
        });
        return arr;
      }
    },
    // 解决 遇到特殊符号可能会转译 问题
    formatForKeyword(keyword) {
      var specChar = [
        "\\",
        "$",
        "(",
        ")",
        "*",
        "+",
        ".",
        "[",
        "]",
        "?",
        "^",
        "{",
        "}",
        "|",
        "'",
        '"',
      ];
      var starttime = new Date().getTime();
      let flag = false;
      for (var i = 0; i < specChar.length; i++) {
        if (keyword.indexOf(specChar[i]) >= 0) {
          flag = true;
          break;
        }
      }
      if (flag) {
        let keywordArr = keyword.split("");
        for (let i = 0; i < keywordArr.length; i++) {
          if (specChar.indexOf(keywordArr[i]) >= 0) {
            keywordArr[i] = "\\" + keywordArr[i];
          }
        }
        keyword = keywordArr.join("");
      }
      console.log("转义time: " + (new Date().getTime() - starttime));
      return keyword;
    },
    clearKeyword() {
      this.query.masterName = "";
      this.communityList = [];
      this.handleSelect();
      // bus.$emit("masterId", "");
      // sessionStorage.setItem('masterId','')
      this.resetSetItem('masterId', '');

    },
    searchON(e) {
      console.log(e);
      if (!this.query.masterName) {
        this.remoteSearch("");
      }
    },
    reset(){
      this.query.masterName = "";
      this.query.searchName = ""
      // this.resetSetItem('masterId','')
      // this.resetSetItem('searchName','')
      this.$emit('changeMasterId','')
        this.$emit('changeSearchName','')
      // bus.$emit("masterId", "");
      // bus.$emit("searchName", "");

    }
  },
};
</script>

<style lang="scss" scoped>
.search-ipt-element {
  width: 100%;

  .el-select{
    width: 300px;
  }
  .el-input{
    width: 300px;
    margin: 0 20px;
  }
}

.el-icon-search {
  position: absolute;
  top: 0;
}

.append-btn {
  display: inline-block;
  background-color: #018388;
  border: #018388 1px solid;
}

.el-select {
  display: inline-block;
}
.option-empty {
  padding: 6px 0;
  padding-left: 20px;
  margin: 0;
  box-sizing: border-box;
  height: 46px;
  font-size: 16px;
  color: #606266;
  line-height: 34px;
}
.option-empty-tip {
  color: #f00;
}
// .el-button--success.is-plain{
//   color:#fff;
//   background: ;
// }
</style>
